export default __webpack_public_path__ + "static/media/delete.7c9a578c.png";